/**
 * Datos de investigación IPSOS 2025
 * Base: 400 casos, margen de error <5%, 8 edificios diferentes
 * Investigación realizada en Chile, aplicable a Chile y Perú
 */

export const DATOS_IPSOS = {
  // Porcentaje de atención: "siempre" (45.2%) + "casi siempre" (40.5%)
  porcentajeAtencion: 85.7,

  // Viajes promedio por día (ponderado de la distribución IPSOS)
  // 4.6% hace 1-2 viajes, 42.8% hace 3-4 viajes, 52.6% hace 5+ viajes
  viajesPorDia: 4.5,

  // Trayectos por viaje (subir y bajar)
  trayectosPorViaje: 2,

  // Trayectos totales por día (4.5 viajes × 2)
  trayectosPorDia: 9,

  // Duración promedio de cada trayecto en segundos
  duracionTrayectoSegundos: 50,

  // Tiempo total en ascensor por día (9 trayectos × 50 seg)
  tiempoEnAscensorPorDia: 450,

  // Frecuencia semanal de asistencia al edificio (promedio ponderado)
  // (1×2.5 + 2×11.9 + 3×14.7 + 4×11.2 + 5×57.8 + 6×1.3 + 7×0.6) / 100 = 4.16
  diasPorSemanaPromedio: 4.16,

  // Métricas adicionales de la investigación
  recallPublicidad: 76.3, // % que recuerda haber visto publicidad
  satisfaccionMedio: 98.1, // % que le gusta el medio
  aportaValor: 96.9, // % que dice que las pantallas aportan valor
  enteradoPorPantallas: 87.6, // % que se enteró de algo por primera vez en pantallas
};

/**
 * Configuración por defecto para el simulador
 */
export const CONFIG_SIMULADOR = {
  // Programación diaria en segundos (14 horas = 50,400 segundos)
  programacionDiariaSegundos: 50400,
  programacionDiariaHoras: 14,

  // Duración de spot por defecto en segundos
  duracionSpotDefault: 12,

  // Frecuencias de exhibición predefinidas (spots por hora por pantalla)
  frecuenciasPorHora: [5, 10, 15, 20, 25, 30],

  // Días de campaña por defecto
  diasCampanaDefault: 30,
};

/**
 * Datos específicos por país
 * Usan los mismos valores de IPSOS Chile 2025
 */
export const DATOS_POR_PAIS = {
  Chile: {
    ...DATOS_IPSOS,
    nombre: "Chile",
    moneda: "CLP",
    marca: "Wecast",
  },
  Perú: {
    ...DATOS_IPSOS,
    nombre: "Perú",
    moneda: "PEN",
    marca: "Visiona",
  },
};

/**
 * Distribución de viajes por día (para mostrar en UI)
 */
export const DISTRIBUCION_VIAJES = {
  "1-2 viajes": 4.6,
  "3-4 viajes": 42.8,
  "5+ viajes": 52.6,
};

/**
 * Distribución de frecuencia semanal de visitas al edificio
 */
export const FRECUENCIA_SEMANAL = {
  "1 vez": 2.5,
  "2 veces": 11.9,
  "3 veces": 14.7,
  "4 veces": 11.2,
  "5 veces": 57.8,
  "6 veces": 1.3,
  "7 veces": 0.6,
};

/**
 * Distribución de atención a las pantallas
 */
export const DISTRIBUCION_ATENCION = {
  Siempre: 45.2,
  "Casi siempre": 40.5,
  "Algunas veces": 14.1,
  "Casi nunca": 0.3,
};
